import React, { useEffect, useState, useRef } from "react";
import Header from "../../../header/header";
import Footer from "../../../footer/footer";
import Sidebar from "../../../Sidebar/Sidebar";
import {
  userProfileDetails,
  getSubscriptionInvoiceDetails,
} from "../../service";
import Skeleton from "../../component/skeleton";
import { IMAGES } from "../../../../../assets/images";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useDispatch, useSelector } from "react-redux";
import { logout, setUser } from "../../../../../store/slices/userSlice";
import { useNavigate } from "react-router-dom";
import { routerPath } from "../../../../navigation/path";
import { toast } from "react-toastify";

function MyAccount() {
  const invoiceRef = useRef(null);
  const [profileDetails, setProfileDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState(false);
  const [invoiceDetails, setinvoiceDetails] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.users.user);

  useEffect(() => {
    getProfileDetails();
    getInvoiceDetails();
  }, []);

  const getProfileDetails = async () => {
    console.log("MyAccount Called");
    try {
      const res = await userProfileDetails();
      console.log("Profile API response:", res);

      if (res.data.is_membership == 0) {
        dispatch(logout());
        toast.success("Your Membership Has Been Expired");
        localStorage.clear();
        localStorage.setItem("currentPath", "/login");
        navigate(routerPath.Login);
      } else {
        // Merge new data with existing user state to preserve token and other fields
        const updatedUser = {
          ...currentUser, // Keep existing user data (includes token)
          ...res.data, // Merge with new profile data
        };

        console.log("Updated user:", updatedUser);
        dispatch(setUser(updatedUser));
        localStorage.setItem("user", JSON.stringify(updatedUser));
        setProfileDetails(res.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getInvoiceDetails = async () => {
    try {
      const res = await getSubscriptionInvoiceDetails();
      console.log(res);
      setinvoiceDetails({ ...res });
      console.log(invoiceDetails);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading2(true);
    }
  };

  const downloadInvoice = async () => {
    if (!invoiceRef.current) return;
    // try {
    //     const canvas = await html2canvas(invoiceRef.current);
    //     console.log(canvas);
    //     const imgData = canvas.toDataURL('image/png');

    //     if (!imgData) {
    //         throw new Error('Failed to generate image from canvas');
    //     }

    //     const link = document.createElement('a');
    //     link.href = imgData;
    //     link.download = 'Subscription Invoice.png';
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    //     console.log('Image downloaded successfully.');
    // } catch (error) {
    //     console.error('Error generating image:', error);
    // }

    try {
      const canvas = await html2canvas(invoiceRef.current, {
        scale: 1.5,
        useCORS: true,
        logging: true,
      });
      const imgData = canvas.toDataURL("image/jpeg", 0.85);
      console.log("Generated image data:", imgData);

      if (!imgData) {
        throw new Error("Failed to generate image from canvas");
      }
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("Subscription_Invoice.pdf");
      console.log("PDF downloaded successfully.");
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  return (
    <>
      <Header />
      <div className="flex">
        <div className="hidden lg:block bg-[#0A142F]">
          <Sidebar />
        </div>
        <main className="flex-1 p-2 sm:p-5 bg-gray-100">
          <h1 className="text-2xl sm:text-3xl lg:text-[46px] font-bold">
            My Account
          </h1>
          <p className="text-gray-500 mb-4 text-[12px] sm:text-[14px]">
            Dashboard / <span className="font-semibold">My Account</span>
          </p>

          {loading ? (
            <>
              <div className="flex flex-col lg:flex-row">
                <div className="w-full lg:w-1/3">
                  <div className="flex flex-col gap-2 sm:gap-4">
                    <div className="flex flex-col items-center bg-white shadow-md rounded-lg p-3 sm:p-4">
                      <Skeleton width="100%" />
                    </div>

                    <div className="bg-white shadow-md rounded-lg p-3 sm:p-4">
                      <Skeleton width="100%" />
                    </div>
                  </div>
                </div>

                <div className="w-full lg:w-2/3 bg-white shadow-md rounded-lg p-3 sm:p-4 ml-0 lg:ml-4 mt-4 lg:mt-0">
                  <Skeleton width="100%" />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="flex flex-col lg:flex-row min-h-screen">
                <div className="w-full lg:w-1/3">
                  <div className="flex flex-col gap-4">
                    <div className="flex flex-col items-center bg-white shadow-md rounded-lg p-4">
                      <img
                        src={IMAGES.userimage}
                        alt="Profile"
                        className="w-[120px] h-[120px] sm:w-[150px] sm:h-[150px] lg:w-[200px] lg:h-[200px] rounded-full object-cover"
                      />
                      <h2 className="text-[16px] sm:text-[18px] font-semibold mt-2 sm:mt-4 text-center">
                        {profileDetails?.data?.name}
                      </h2>
                      <p className="text-[#888888] text-[12px] sm:text-[14px] text-center break-all">
                        {profileDetails?.data?.email}
                      </p>
                    </div>

                    <div className="bg-white shadow-md rounded-lg p-3 sm:p-4">
                      <h3 className="text-[16px] sm:text-[18px] font-semibold mb-3 sm:mb-4">
                        My Subscription
                      </h3>
                      <button
                        className="bg-gray-300 text-black px-2 py-1 rounded-md hover:bg-sky-500 mb-3 hover:border-0 text-[12px] sm:text-[14px] hover:!text-white w-full sm:w-auto"
                        style={{ border: "1px solid white" }}
                        onClick={downloadInvoice}
                      >
                        Print Invoice
                      </button>

                      <h4 className="text-[14px] sm:text-[16px] font-semibold mb-1">
                        Membership
                      </h4>
                      <p className="text-[14px] sm:text-[16px]">
                        {profileDetails?.subscription?.name}
                      </p>
                      <div className="w-full lg:w-[90%] flex flex-col sm:flex-row sm:justify-between gap-2 sm:gap-0">
                        <div>
                          <h4 className="text-[14px] sm:text-[16px] font-semibold">
                            Start Date
                          </h4>
                          <p className="text-[14px] sm:text-[16px]">
                            {profileDetails?.subscription?.validity_start_date}
                          </p>
                        </div>
                        <div>
                          <h4 className="text-[14px] sm:text-[16px] font-semibold">
                            End Date
                          </h4>
                          <p className="text-[14px] sm:text-[16px]">
                            {profileDetails?.subscription?.validity_end_date}
                          </p>
                        </div>
                      </div>

                      <h4 className="text-[14px] sm:text-[16px] font-semibold mb-1 mt-3">
                        Subscription Status:
                      </h4>
                      <span className="py-1 px-2 text-[#58A942] border border-[#58A942] rounded-[40px] bg-green-200 text-[14px] sm:text-[16px] inline-block">
                        {profileDetails?.subscription?.status}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="w-full lg:w-2/3 bg-white shadow-md rounded-lg p-3 sm:p-4 ml-0 lg:ml-4 mt-4 lg:mt-0">
                  <h1 className="text-[18px] sm:text-[20px] font-bold mb-4 sm:mb-6 text-[#101828]">
                    My Account
                  </h1>
                  <div className="border-b border-gray-300 p-3 sm:p-4 rounded-lg mb-4 sm:mb-6">
                    <h2 className="text-[32px] sm:text-[40px] lg:text-[48px] font-bold text-[#1D2939]">
                      {profileDetails?.total_saving}
                    </h2>
                    <p className="text-[14px] sm:text-[16px] text-[#101828]">
                      Total Savings
                    </p>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
                    <div className="text-[14px] sm:text-[16px]">
                      {/* <p>
                                            <strong>Name:</strong> {profileDetails.data.name}
                                        </p> */}
                      <p className="mb-2">
                        <strong>Name:</strong>{" "}
                        {profileDetails?.data?.name?.split(" ")[0] || "N/A"}
                      </p>
                      <p className="mb-2">
                        <strong>Last Name:</strong>{" "}
                        {profileDetails?.data?.name?.split(" ")[1] || "N/A"}
                      </p>
                    </div>
                    <div className="text-[14px] sm:text-[16px]">
                      <p className="mb-2 break-all">
                        <strong>Email:</strong> {profileDetails?.data?.email}
                      </p>
                      <p className="mb-2">
                        <strong>Mobile Number:</strong>{" "}
                        {profileDetails?.data?.mobile}
                        <span className="text-blue-500 ml-2 cursor-pointer">
                          Edit
                        </span>
                      </p>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 mt-4 sm:mt-6">
                    <div className="border p-3 sm:p-4 rounded-lg">
                      <h3 className="font-semibold mb-2 text-[14px] sm:text-[16px]">
                        Billing Address
                      </h3>
                      <p className="text-[13px] sm:text-[15px]">
                        4th, Mitra Towers, 10/4, Kasturba Rd, Shanthal Nagar,
                        Ashok Nagar, Bengaluru, Karnataka 560001
                      </p>
                      <div className="mt-3 sm:mt-4 text-[14px]">
                        <span className="text-blue-500 cursor-pointer mr-4">
                          Edit
                        </span>
                        <span className="text-blue-500 cursor-pointer">
                          Remove
                        </span>
                      </div>
                    </div>

                    <div className="border p-3 sm:p-4 rounded-lg">
                      <h3 className="font-semibold mb-2 text-[14px] sm:text-[16px]">
                        Shipping Address
                      </h3>
                      <p className="text-[13px] sm:text-[15px]">
                        4th, Mitra Towers, 10/4, Kasturba Rd, Shanthal Nagar,
                        Ashok Nagar, Bengaluru, Karnataka 560001
                      </p>
                      <div className="mt-3 sm:mt-4 text-[14px]">
                        <span className="text-blue-500 cursor-pointer mr-4">
                          Edit
                        </span>
                        <span className="text-blue-500 cursor-pointer">
                          Remove
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {loading2 && (
                <>
                  <div className="absolute -top-[99999px] -left-[99999px] flex justify-center items-center">
                    <div
                      ref={invoiceRef}
                      className="bg-white border border-gray-300 p-5 w-full max-w-3xl mx-auto"
                    >
                      {/* Header Section */}
                      <div className="flex flex-col justify-center items-center mb-5">
                        <img
                          src={IMAGES.finalLogo}
                          alt="Logo"
                          className="w-[150px] max-w-full h-auto mb-2"
                        />
                      </div>

                      {/* Customer & Order Details */}
                      <div className="mb-5">
                        <table className="w-full text-sm">
                          <tbody>
                            <tr>
                              <td className="py-1 font-medium text-gray-700">
                                Name:
                              </td>
                              <td className="py-1 text-right text-gray-700">
                                {invoiceDetails?.current_user}
                              </td>
                            </tr>
                            <tr>
                              <td className="py-1 font-medium text-gray-700">
                                Order Number:
                              </td>
                              <td className="py-1 text-right text-gray-700">
                                {invoiceDetails?.order_details?.order_number}
                              </td>
                            </tr>
                            <tr>
                              <td className="py-1 font-medium text-gray-700">
                                Order Date:
                              </td>
                              <td className="py-1 text-right text-gray-700">
                                {invoiceDetails?.order_details?.order_date}
                              </td>
                            </tr>
                            <tr>
                              <td className="py-1 font-medium text-gray-700">
                                Mobile:
                              </td>
                              <td className="py-1 text-right text-gray-700">
                                {invoiceDetails?.order_details?.mobile}
                              </td>
                            </tr>
                            <tr>
                              <td className="py-1 font-medium text-gray-700">
                                Email:
                              </td>
                              <td className="py-1 text-right text-gray-700">
                                {invoiceDetails?.order_details?.email}
                              </td>
                            </tr>
                            <tr>
                              <td className="py-1 font-medium text-gray-700">
                                Payment Method:
                              </td>
                              <td className="py-1 text-right text-gray-700">
                                {invoiceDetails?.order_details?.payment_method}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* Product Details */}
                      <div className="mb-5">
                        <h3 className="mb-3 text-base font-semibold text-gray-800">
                          Product Details
                        </h3>
                        <table className="w-full border-collapse border border-gray-300 text-sm">
                          <thead>
                            <tr className="bg-gray-100">
                              <th className="border border-gray-300 py-2 px-3 text-left  min-w-64 max-w-72">
                                Product
                              </th>
                              <th className="border border-gray-300 py-2 px-3 text-right">
                                Price
                              </th>
                              <th className="border border-gray-300 py-2 px-3 text-right">
                                Quantity
                              </th>
                              <th className="border border-gray-300 py-2 px-3 text-right">
                                Subtotal
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="border border-gray-300 py-2 px-3">
                                {invoiceDetails?.products?.name}
                              </td>
                              <td className="border border-gray-300 py-2 px-3 text-right">
                                ₹ {invoiceDetails?.products?.prize}
                              </td>
                              <td className="border border-gray-300 py-2 px-3 text-right">
                                {invoiceDetails?.products?.qty}
                              </td>
                              <td className="border border-gray-300 py-2 px-3 text-right">
                                ₹ {invoiceDetails?.products?.subtotal}
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td
                                colSpan="3"
                                className="border border-gray-300 py-2 px-3 text-left"
                              >
                                SubTotal
                              </td>
                              <td className="border border-gray-300 py-2 px-3 text-right">
                                ₹ {invoiceDetails?.products?.subtotal}
                              </td>
                            </tr>
                            <tr>
                              <td
                                colSpan="3"
                                className="border border-gray-300 py-2 px-3 text-left"
                              >
                                Discount
                              </td>
                              <td className="border border-gray-300 py-2 px-3 text-right">
                                -₹ {invoiceDetails?.products?.discount}
                              </td>
                            </tr>
                            <tr className="bg-gray-100">
                              <td
                                colSpan="3"
                                className="border border-gray-300 py-2 px-3 text-left font-bold"
                              >
                                Total
                              </td>
                              <td className="border border-gray-300 py-2 px-3 text-right font-bold">
                                ₹ {invoiceDetails?.products?.total}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>

                      {/* Footer Section */}
                      <div className="text-center mt-5 text-xs text-gray-500">
                        <p>Thank you for your business!</p>
                        <p>For support, contact support@bizprime.com</p>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </main>
      </div>
      <Footer />
    </>
  );
}

export default MyAccount;
